<div class="item-container">
  <p class="content-main-color body1--bold">{{ 'LAST_CATEGORY.BROWSE' | translate }}</p>
  <app-last-category-item-card></app-last-category-item-card>
</div>
